import styled, { css } from 'styled-components'

const StyledEditableRowLoaderContainer = styled.div`
  position: absolute;
  z-index: 10;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  ${props =>
    props.height &&
    css`
      height: ${props.height}px;
    `};
`

export default StyledEditableRowLoaderContainer
